module.exports = __webpack_public_path__ + "img/node-industry-transparent.bfd14997.webp";